import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Dropdown, Label } from 'semantic-ui-react';
import { FiCheckSquare } from 'react-icons/fi';
import MediaQuery from 'react-responsive';

// Selectors
// @ts-ignore
import { selectSelectedTableRowsExist } from 'services/selectedTableCells/selectors';

// Components
// @ts-ignore
import SelectedTableRowsCount from 'components/SelectedTableRowsCount';

export interface OwnProps {
    DropdownMenu: React.ReactNode;
}

interface StateProps {
    exist: boolean;
}

type Props = StateProps & OwnProps;

export class SelectedTableCellsBulkActionsDropdown extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { DropdownMenu, exist } = this.props;

        return (
            <React.Fragment>
                <MediaQuery maxWidth={1024}>
                    <Dropdown
                        floating
                        icon={null}
                        direction="left"
                        disabled={!exist}
                        trigger={
                            <Button
                                circular
                                icon
                                style={{
                                    position: 'relative',
                                    padding: 0,
                                    background: 'transparent',
                                    color: '#fff',
                                    boxShadow: 'none',
                                    marginLeft: 5
                                }}
                            >
                                <FiCheckSquare
                                    size="24"
                                    style={{ verticalAlign: 'middle' }}
                                />
                                {exist && (
                                    <Label
                                        circular
                                        color="red"
                                        floating
                                        size="mini"
                                    >
                                        <SelectedTableRowsCount />
                                    </Label>
                                )}
                            </Button>
                        }
                    >
                        {DropdownMenu}
                    </Dropdown>
                </MediaQuery>
                {exist && (
                    <MediaQuery minWidth={1025}>
                        <Dropdown
                            floating
                            icon={null}
                            trigger={
                                <Button
                                    color="blue"
                                    size="small"
                                    // icon
                                    circular
                                    style={{
                                        boxShadow: 'none',
                                        margin: 0,
                                        marginLeft: 5,
                                        marginRight: 5
                                    }}
                                >
                                    <SelectedTableRowsCount />
                                    {' Selected'}
                                </Button>
                            }
                        >
                            {DropdownMenu}
                        </Dropdown>
                    </MediaQuery>
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    exist: selectSelectedTableRowsExist
});

export default connect<StateProps, OwnProps>(mapStateToProps)(
    SelectedTableCellsBulkActionsDropdown
);
